import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, Headphones, Users } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center mt-[-50px] mb-[-50px] space-y-[0px] pt-[10px] pb-[10px]" data-id="element-196">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex items-center gap-2 bg-[#7c3aed]/10 text-[#5b21b6] px-4 py-1.5 rounded-full font-bold border border-[#7c3aed]/30 mt-[0px] mb-[0px] text-[14px] shadow-sm" data-id="element-197">
        <span data-id="element-198">🎵</span> TU MANUAL DIGITAL™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-7xl font-extrabold tracking-tight text-balance mt-[-5px] mb-[-5px] text-[28px] text-[#1f1b16]" data-id="element-199">
        El sistema que convierte el sonido en tu herramienta de bienestar más
        poderosa
      </motion.h1>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="mb-8 space-y-[0px]" data-id="element-200"></motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="flex flex-col items-center justify-center my-6" data-id="element-201">
        <img src="https://cdn.magicpatterns.com/uploads/hnkATzjdA6YnE1VCghC7SK/mockup_botiquin_vibracional-removebg-preview.png" alt="Botiquín Vibracional Pro - Mockup del producto" className="w-[62.5%] max-w-[17.5rem] md:max-w-sm drop-shadow-[0_20px_40px_rgba(124,58,237,0.3)] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-202" />
        <p className="md:text-2xl text-[#1f1b16] font-bold pt-[5px] pb-[5px] text-[16px]" data-id="element-203">
          Para personas con ansiedad, insomnio, agotamiento y dolor que quieren
          regularse, descansar profundo y rendir más — sin pastillas, sin
          terapias caras y sin años de práctica.
        </p>
        <p className="text-[#6b6358] font-medium pt-[0px] pb-[0px] mt-[0px] mb-[0px] text-[12px]" data-id="element-204">
          Regulación · Sueño · Productividad · Cuerpo · Entorno · Transformación
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 text-xs md:text-sm font-bold text-[#6b6358] mt-[0px] mb-[0px] items-stretch justify-center pt-[10px] pb-[10px]" data-id="element-205">
        <div className="flex items-center justify-center gap-1 bg-[#faf7f2] px-3 py-1.5 rounded-md border border-[#e7dfce] whitespace-nowrap shadow-sm" data-id="element-206">
          <FileText size={14} className="text-[#7c3aed]" data-id="element-207" /> 100% PDF
        </div>
        <div className="flex items-center justify-center gap-1 bg-[#faf7f2] px-3 py-1.5 rounded-md border border-[#e7dfce] whitespace-nowrap font-bold shadow-sm" data-id="element-208">
          <Zap size={14} className="text-[#7c3aed]" data-id="element-209" /> Acceso al instante
        </div>
        <div className="flex items-center justify-center gap-1 bg-[#faf7f2] px-3 py-1.5 rounded-md border border-[#e7dfce] whitespace-nowrap shadow-sm" data-id="element-210">
          <Users size={14} className="text-[#7c3aed]" data-id="element-211" /> Para toda la familia
        </div>
        <div className="flex items-center justify-center gap-1 bg-[#faf7f2] px-3 py-1.5 rounded-md border border-[#e7dfce] whitespace-nowrap shadow-sm" data-id="element-212">
          <Headphones size={14} className="text-[#7c3aed]" data-id="element-213" /> Todos los niveles
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="flex flex-col items-center" data-id="element-214">
        <a href="#pricing" className="group relative inline-flex px-8 py-5 text-xl font-black text-[#0f0d09] bg-[#7c3aed] rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-[#a78bfa] shadow-[0_10px_40px_rgba(124,58,237,0.4)] animate-pulse-slow w-full max-w-md gap-[0px] items-center justify-center pt-[10px] pb-[10px] pl-[0px] pr-[0px] mt-[0px] mb-[0px]" data-id="element-215">
          <span className="relative z-10 flex gap-[10px] items-center justify-center text-[18px] pt-[4px] pb-[4px] text-white" data-id="element-216">
            → QUIERO MI BOTIQUÍN VIBRACIONAL PRO AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-217" />
        </a>

        <div className="flex flex-wrap justify-center mt-6 text-sm text-[#6b6358] font-medium gap-[8px]" data-id="element-218">
          <span className="flex items-center gap-1.5" data-id="element-219">
            <Shield size={16} className="text-[#7c3aed]" data-id="element-220" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-221">
            <Lock size={16} className="text-[#7c3aed]" data-id="element-222" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-223">
            <CreditCard size={16} className="text-[#7c3aed]" data-id="element-224" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}